import { JobPost } from "@/pages/_layouts/jobs/types";
import classNames from "classnames";
import SectionHeading from "@/components/SectionHeading";
import { renderContent } from "@/lib/htmlContentHelpers";
import "@/lib/htmlContent.css";

interface JobContentSectionsProps {
  jobPost: JobPost;
}

export function JobContentSections({ jobPost }: JobContentSectionsProps) {
  const sections = [
    { title: "Overview", content: jobPost.overview, testId: "job-content-overview" },
    { title: "Experience Required", content: jobPost.requiredExperienceDescription, testId: "job-content-experience" },
    {
      title: "Essential Responsibilities",
      content: jobPost.essentialResponsibilities,
      isList: true,
      testId: "job-content-responsibilities"
    },
    { title: "Benefits", content: jobPost.benefits, isList: true, testId: "job-content-benefits" },
    {
      title: "Additional Income",
      content: jobPost.additionalIncome,
      isList: true,
      testId: "job-content-income"
    }
  ];

  return (
    <>
      {sections.map((section, index) => (
        <div
          key={index}
          className="border-0 border-b border-sys-brand-secondary-container pb-6"
          data-testid={section.testId}
        >
          <SectionHeading heading={section.title} />
          <div
            className={classNames("text-body-large break-words text-sys-brand-on-surface", {
              "opacity-20": !section.content
            })}
          >
            {renderContent(section.content, { enhancedCleanup: false })}
          </div>
        </div>
      ))}
    </>
  );
}
